import { ApiMessageHandler, ArtAlert, DynamicForm, useApiService, withFormService } from "@art/shared-ui";
import { validators } from "@art/shared-ui";
import { useState } from "react";

function ArtEnvironmentAddPage({ data, onSave, onInit }: any) {
  const apiService = useApiService();
  const [saveError, setSaveError] = useState("");

  const formBuilder = (data: any) => {
    return [
      {
        type: "hidden",
        id: "id",
        value: data?.id,
      },
      {
        type: "row",
        children: [
          {
            type: "col",
            classNames: ["col-12"],
            children: [
              {
                id: "title",
                label: "Environment Name",
                type: "text",
                placeholder: "STAGING",
                required: true,
                marginBottom: "0px",
                value: data?.title,
                validate: validators((value) => {
                  if (!value || value.trim() === "") {
                    return "Environment name is required.";
                  }
                  if (value.length > 20) {
                    return "Title cannot be longer than 20 characters.";
                  }
                  if (value.trim().length < 3) {
                    return "Title must be at least 3 characters long.";
                  }
                  if (!/^[A-Za-z]+$/.test(value)) {
                    return "Environment name can only contain letters.";
                  }
                  return null;
                }),
              },
            ],
          },
        ],
      },
    ];
  };

  return (
    <>
    {saveError && <ArtAlert severity="error" sx={{ mb: 2 }}>{saveError}</ArtAlert>}
    <DynamicForm
      formBuilder={formBuilder}
      onInit={onInit}
      onSubmit={
        apiService.saveData(data ? `/environments/${data.id}` : "/environments", data ? "put" : "post", {
          onApiCall: (values) => {
            setSaveError("");
            return values;
          },
          onSuccess: () => onSave(),
          onError: (error: unknown) => setSaveError(ApiMessageHandler.extractErrorMessage(error)),
        })
      }
    />
    </>
  );
}

export default withFormService(ArtEnvironmentAddPage);
